<template>
  <div class="todo-form">
    <div v-for="item in sortedItems" :key="item.id" class="form-row">
      <label class="form-label">{{ item.name }}</label>
      <template v-if="item.input_type === 'TEXT'">
        <input
          class="form-input"
          type="text"
          v-model="form[item.id]"
          @input="$emit('editing')"
        />
      </template>
      <div
        v-else-if="item.input_type === 'RADIO_BUTTON'"
        class="form-radio-group"
      >
        <label
          v-for="opt in item.select_options"
          :key="opt.id"
          class="form-radio"
        >
          <input
            type="radio"
            :name="item.id"
            :value="opt.id"
            v-model="form[item.id]"
            @input="$emit('editing')"
          />
          {{ opt.label }}
        </label>
      </div>
    </div>
    <FormButtonList @save="onSave" @cancel="onCancel" />
  </div>
</template>

<script>
import EnterpriseManningVesselCrewTodoService from "../../../services/master/EnterpriseManningVesselCrewTodoService";
import FormButtonList from "./FormButtonList.vue";
export default {
  name: "ManningVesselCrewTodo",
  components: { FormButtonList },
  props: {
    master: { type: Object, required: true },
    value: {
      type: Object,
      default: () => ({
        todo_values: [],
      }),
    },
    crewId: {
      type: [String, Number],
      required: true,
    },
    version: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    sortedItems() {
      if (!this.master || !Array.isArray(this.master.items)) return [];
      return [...this.master.items].sort((a, b) => a.sort_order - b.sort_order);
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        const INPUT_TYPE = {
          RADIO_BUTTON: "RADIO_BUTTON",
          TEXT: "TEXT",
        };

        if (this.master && this.master.id) {
          const formMap = {};
          this.master.items.forEach(item => {
            let todovalue = null;
            if (newVal.todo_values && Array.isArray(newVal.todo_values)) {
              todovalue = newVal.todo_values.find(
                todo =>
                  todo.todo_id === this.master.id &&
                  todo.items.some(
                    todoValuesItem => todoValuesItem.todo_item_id === item.id
                  )
              );
            }
            // Valueが空の場合は初期値を設定
            let value = "";
            if (todovalue && todovalue.items) {
              const todoItem = todovalue.items.find(
                i => i.todo_item_id === item.id
              );
              if (todoItem) {
                value = todoItem.input_value || "";
              }
            }

            if (item.input_type === INPUT_TYPE.RADIO_BUTTON) {
              formMap[item.id] =
                value === "" ? item.select_options[0].id : value;
            } else if (item.input_type === INPUT_TYPE.TEXT) {
              formMap[item.id] = value;
            }
          });

          this.form = formMap;
        } else {
          this.form = {};
        }
      },
    },
  },
  methods: {
    async onSave() {
      const todoValues = this.value.todo_values.flatMap(v => v.items);
      const latestMap = {};
      todoValues.forEach(item => {
        const id = item.todo_item_id;
        if (!latestMap[id] || Number(item.id) > Number(latestMap[id].id)) {
          latestMap[id] = item;
        }
      });

      const items = this.sortedItems.map(item => {
        const latest = latestMap[item.id];
        const obj = {
          input_value: this.form[item.id],
          item_id: +item.id,
        };
        if (latest && latest.id != null) obj.id = +latest.id;
        if (latest && latest.version != null) obj.version = +latest.version;
        return obj;
      });
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: "保存",
        text: "保存しますか？",
        cancelText: "キャンセル",
        acceptText: "OK",
        accept: async () => {
          try {
            await EnterpriseManningVesselCrewTodoService.updateValue(
              this.crewId,
              this.master.id,
              { items }
            );
            this.$emit("refresh");
            this.$emit("saved");
          } catch (e) {
            this.$emit("save-failed");
          }
        },
        cancel: () => {},
      });
    },
    onCancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped>
.todo-form {
  padding: 16px;
  font-size: 12px;
}

.form-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  height: 44px;
  gap: 16px;
}

.form-label {
  width: 73px;
  font-weight: bold;
}

.form-input {
  flex: 1;
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 2px;
  height: 44px;
}

.form-radio-group {
  display: flex;
  width: 100%;
  flex: 1;
  justify-content: space-between;
}

.form-radio {
  display: flex;
  align-items: center;
  font-size: 12px;
  gap: 8px;
}

.form-radio input[type="radio"] {
  appearance: none;
  -webkit-appearance: none;
  background-color: #fff;
  border: 2px solid #b0b0b0;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  position: relative;
  cursor: pointer;
  outline: none;
  transition: border-color 0.2s;
  vertical-align: middle;
}

.form-radio input[type="radio"]:checked::before {
  content: "";
  display: block;
  width: 14px;
  height: 14px;
  background: #b0b0b0;
  border-radius: 50%;
  position: absolute;
  top: 4px;
  left: 4px;
}
</style>
